<link rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
<div *ngIf="isContentLoaded" class="dialog">
    <div mat-dialog-title class="padding-zero">
        <div class="row justify-content-between header_box">
            <div class="header">
                Primary Competency and Sub-Competency Change Request
            </div>
            <button class="close-button" (click)="onCancel()" disableRipple>
                <span class="material-symbols-outlined">
                    close
                </span>
            </button>
        </div>
    </div>
    <div mat-dialog-content class="containerForEmployeeAlreadyRequest" *ngIf = "IsEmployeeRequestedForCompetency">
        <div class="contentForEmployeeAlreadyRequest">
            <div class="content_textForEmployeeAlreadyRequest">
                <div>
                    <div><b>
                    <p style="position: absolute; left: 20%; top: 50%;">
                        Your Request is in process. COE Team is reviewing, please wait until COE Team's Response
                    </p>

                    <p style="position: absolute; left: 25%; top: 80%; color: black;">
                        For Any Queries, please reach out to <a href="https://outlook.office.com/mail/deeplink/compose?to=GSD-Support@innovasolutions.com" target="_blank" >GSD-Support@innovasolutions.com</a>
                        
                    </b></div>
                    </div>
            </div>
        </div>
    </div>
    
    <div mat-dialog-content [class.apply-min-width]="showComments"
        class="container" *ngIf="!IsEmployeeRequestedForCompetency">
        <div class="row Competency">
            <div class="col-6">

                <div class="comments-label">Current Competency<sup class="error">*</sup>
                </div>
                <div class="dropdown">
                    <mat-form-field class="custom_select">
                        <input class="input-style" matInput [value]="defaultCompetencyName" disabled >
                    </mat-form-field>
                </div>
            </div>
            <div class="col-6">
                <div class="comments-label">
                    Current Sub-Competency <sup class="error">*</sup>
                </div>
                <div class="dropdown">
                    <mat-form-field class="custom_select">
                        <input class="input-style" matInput [value]="defaultSubCompetencyName" disabled>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-6">

                <div class="comments-label">New Competency<sup class="error">*</sup>
                </div>
                <div class="dropdown">
                    <mat-form-field class="custom_select" [ngClass]="{'errorborder': invalidcompetency}">
                        <mat-select placeholder="Select Competency" [(value)]="selectedCompetency"
                            (selectionChange)="onCompetencySelect($event.value)">
                            <mat-option *ngFor="let competency of competencies"
                                [value]="competency.id">{{competency.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="invalidcompetency" class="error">Competency is required</div>
            </div>
            <div class="col-6">
                <div class="comments-label">
                    New Sub-Competency <sup class="error">*</sup>
                </div>
                <div class="dropdown">
                    <mat-form-field class="custom_select" [ngClass]="{'errorborder': invalidsubcompetency}">
                        <mat-select placeholder="Select Sub-Competency" [(value)]="selectedSubCompetency"
                            (selectionChange)="onsubCompetencySelect($event.value)">
                            <mat-option *ngFor="let subCompetency of subCompetencies"
                                [value]="subCompetency.id">{{subCompetency.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="invalidsubcompetency" class="error">Sub Competency is required</div>
            </div>
            <div class="col-6">
                <div class="comments-label">
                    Primary Skills <sup class="error">*</sup><span class="optional-text"> (Max 3)</span>
                </div>
                <div class="form-control multiSelect-textbox field_value custom_Scrollbar"
                    [ngClass]="{'errorborder': invalidprimaryskills}">
                    <ng-container>
                        <app-typeahead-textbox [limitedSelection]="selectedprimaryskills.length >= 3"
                            placehold="Select Primary Skills" [allValues]="primaryskills"
                            (emittedValues)="updateprimaryskills($event)"
                            [values]="selectedprimaryskills"></app-typeahead-textbox>
                    </ng-container>
                </div>
                <div *ngIf="invalidprimaryskills" class="error">Primary Skills is required</div>
            </div>
            <div class="col-6">
                <div class="comments-label">
                    Secondary Skills <sup class="error">*</sup><span class="optional-text"> (Max 3)</span>
                </div>
                <div class="form-control multiSelect-textbox field_value custom_Scrollbar"
                    [ngClass]="{'errorborder': invalidsecondaryskills}">
                    <ng-container>
                        <app-typeahead-textbox [limitedSelection]="selectedsecondaryskills.length >= 3"
                            placehold="Select Secondary Skills" [allValues]="secondaryskills"
                            (emittedValues)="updatesecondaryskills($event)"
                            [values]="selectedsecondaryskills"></app-typeahead-textbox>
                    </ng-container>
                </div>
                <div *ngIf="invalidsecondaryskills" class="error">Secondary Skills is required</div>
            </div>
            <div class="comments-section w-100">
                <label for="comments" class="comments-label">Comments: <sup class="error">*</sup></label>
                <textarea id="comments" placeholder="Enter comments here..." class="comments-input"
                    [(ngModel)]="requestedComments"></textarea>
                <div *ngIf="invalidComments" class="error">Comments are required</div>

            </div>
        </div>
        <div mat-dialog-actions class="actions">

            <button class="btn btn-outline btn-spacing" mat-dialog-close>
                Cancel
            </button>
            <button class="btn btn-primary" (click)="submit()">
                Submit
            </button>
        </div>

    </div>
</div>